import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Clock } from "lucide-react";

// Read-only visibility for the founding six-month comp-expiry sweep: which founding comps
// expire within 30 days (rate returns to Standard on expiry unless they pick a plan), plus the
// ones the scheduled sweep resolved in the last 30 days. The sweep itself is scheduled server-side.
export function FoundingCompsExpiring() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/admin/membership/comps-expiring?within_days=30")
      .then(({ data }) => setData(data))
      .catch(() => setData(null));
  }, []);

  if (!data) return null;
  const upcoming = data.upcoming || [];
  const expired = data.recently_expired || [];
  if (upcoming.length === 0 && expired.length === 0) return null;

  return (
    <div className="pt-1" data-testid="founding-comps-expiring">
      <div className="inline-flex flex-col gap-1 border border-volt/30 bg-volt/5 px-3 py-2 max-w-xl">
        <div className="flex items-center gap-1.5 font-mono uppercase text-[10px] tracking-wide text-volt">
          <Clock className="w-3.5 h-3.5" /> Founding comps expiring (next 30 days)
        </div>
        {upcoming.length === 0 ? (
          <span className="font-mono text-[11px] text-muted-foreground normal-case">None expiring in the next 30 days.</span>
        ) : (
          <div className="flex flex-wrap gap-1" data-testid="comps-expiring-upcoming">
            {upcoming.map((u) => (
              <span key={u.user_id} data-testid={`comp-expiring-${u.username}`}
                title={`expires ${(u.expires_at || "").slice(0, 10)} · ${u.reason || ""}`}
                className="font-mono text-[10px] px-1.5 py-0.5 border border-volt/30 text-volt/90 normal-case">
                @{u.username} · {u.days_left}d
              </span>
            ))}
          </div>
        )}
        {expired.length > 0 && (
          <div className="flex flex-wrap items-center gap-1 pt-0.5" data-testid="comps-recently-expired">
            <span className="font-mono uppercase text-[9px] tracking-wide text-muted-foreground">Resolved (30d):</span>
            {expired.map((u) => (
              <span key={u.user_id} data-testid={`comp-expired-${u.username}`}
                title={`expired ${(u.expired_at || "").slice(0, 10)} · rate returned to Standard`}
                className="font-mono text-[10px] px-1.5 py-0.5 border border-sniper text-muted-foreground normal-case">
                @{u.username}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
